<template>
  <div class="home cupons cupon-page" v-if="cupon">
    <h2>קופון {{cupon.cupon}}</h2>

    <div class="box has-background-light">
      <div class="columns">
        <div class="column has-text-left is-1">
          <router-link class="button" :to="{name: 'cupons'}">
            חזור
          </router-link>
        </div>
      </div>
    </div>
    <cupon-users :subs="cuponUsers"></cupon-users>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";

import CuponUsers from "@/components/CuponUsers";

export default {
  components: {
    CuponUsers
  },

  computed: {
    cupon() {
      return this.$store.getters.getCuponById(this.$route.params.id);
    },
    cuponUsers() {
      return this.$store.state.cuponUsers;
    }
  },

  created() {
    if (typeof this.cupon === "undefined") {
      this.$store.dispatch("getCupon", this.$route.params.id);
    } else {
      this.$store.dispatch("getCuponUsers", this.cupon);
    }
  }
};
</script>

<style lang="scss">
.cupon-page {
  .box {
    .columns {
      flex-direction: row-reverse;
    }
  }
}
</style>
